const routes = [
  {
    index: true,
    label: "Zhang's page",
    path: '/',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Blogs',
    path: '/blogs',
  },
  {
    label: '温泉収集',
    path: '/onsen',
  },
];

export default routes;
